import React from "react";
import ReactMarkdown from "react-markdown";
//// DEVELOPMENT
// import $ from 'jquery';
export class SpeakerModal extends React.Component {
  closePopup(speakerId) {
    try {
      let modalRef = $(`.tint-speaker[modalId=${speakerId}]`);
      if (modalRef) {
        modalRef.hide();        
      }
    } catch (error) {}
  }

  render() {
    let { data: speaker } = this.props;

    return (
      <div modalId={speaker.id} className="tint-speaker">
        <div          
          className="close-popup"
          onClick={this.closePopup.bind(this, speaker.id)}
        />
        <div className="popup-bg">
          <div className="speaker-details">
            <img
              src={speaker.profilePicture.url}
              alt={speaker.name}
              width="180"
              className="rounded-img"
            />
            <div className="sm-spacing" />
            <h6 className="h6">
              <strong>{speaker.name}</strong>
              <br />
            </h6>
            <div className="small-copy">{speaker.role}</div>
          </div>
          <div className="popup-content">
            <ReactMarkdown source={speaker.bio} escapeHtml={false} />
          </div>
        </div>
      </div>
    );
  }
}
export default SpeakerModal;
